const isMacLike = (/(Mac|iPhone|iPod|iPad)/i).test(window.navigator.platform);

export {isMacLike};
